import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template"]

  connect() {
    this.wrapperClass = this.data.get("wrapperClass") || ".nested-fields"
    this.template = `
      <div class="nested-fields relative flex items-center space-x-4 p-4 border rounded-lg" data-new-record="true">
        <div class="flex-shrink-0">
          <img src="" class="w-6 h-6 hidden" alt="Favicon">
        </div>
        <div class="flex-1 grid grid-cols-2 gap-4">
          <div class="col-span-1">
            <input type="text" name="todo[links_attributes][NEW_RECORD][title]" class="tw-form-control" placeholder="Titel">
          </div>
          <div class="col-span-1">
            <input type="text" name="todo[links_attributes][NEW_RECORD][url]" class="tw-form-control" placeholder="URL" data-action="change->nested-form#updateFavicon">
          </div>
        </div>
        <div class="flex-shrink-0">
          <input type="hidden" name="todo[links_attributes][NEW_RECORD][_destroy]" value="0">
          <button type="button" class="text-red-500 hover:text-red-700" data-action="nested-form#remove_association">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
          </button>
        </div>
      </div>
    `
  }

  add_association(event) {
    event.preventDefault()
    const content = this.template.replace(/NEW_RECORD/g, new Date().getTime())
    this.element.querySelector('.space-y-4').insertAdjacentHTML('beforeend', content)
  }

  remove_association(event) {
    event.preventDefault()
    const wrapper = event.target.closest(this.wrapperClass)
    
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      wrapper.style.display = 'none'
      wrapper.querySelector("input[name*='_destroy']").value = 1
    }
  }

  updateFavicon(event) {
    const url = event.target.value
    const faviconContainer = event.target.closest(this.wrapperClass).querySelector('.flex-shrink-0 img')
    
    if (url) {
      try {
        const faviconUrl = `https://www.google.com/s2/favicons?domain=${new URL(url).hostname}&sz=32`
        faviconContainer.src = faviconUrl
        faviconContainer.classList.remove('hidden')
      } catch (e) {
        faviconContainer.classList.add('hidden')
      }
    } else {
      faviconContainer.classList.add('hidden')
    }
  }
}